// Categorized roles for better UX in the new form
export const ROLE_CATEGORIES = {
  "醫師與牙醫": [
    "西醫",
    "中醫",
    "牙醫",
    "牙醫助理"
  ],
  "護理與藥事": [
    "護理師",
    "藥師"
  ],
  "相關醫療專業": [
    "治療師",
    "醫檢師",
    "放射師",
    "社工師",
    "諮商心理師",
    "臨床心理師",
    "營養師",
    "其他專業醫療人員"
  ],
  "學生": [
    "學生"
  ],
  "福音與庶務支援": [
    "福音人員",
    "資訊&影音",
    "音樂事奉",
    "義剪人員",
    "庶務人員"
  ]
};

// 需要填寫報備支援狀態的專業醫療／醫事職類。
// 不包含學生、牙醫助理與福音庶務支援角色。
export const OFFICIAL_SUPPORT_ROLES = [
  "西醫",
  "中醫",
  "牙醫",
  "護理師",
  "藥師",
  "治療師",
  // Legacy role values kept for existing records created before the therapist parent role.
  "物理治療師",
  "職能治療師",
  "語言治療師",
  "呼吸治療師",
  "醫檢師",
  "放射師",
  "社工師",
  "諮商心理師",
  "臨床心理師",
  "營養師",
  "其他專業醫療人員"
];

// 治療師次分類
export const THERAPIST_SPECIALTIES = [
  "物理治療師",
  "職能治療師",
  "語言治療師",
  "呼吸治療師"
];

// 學生專業科目選項
export const STUDENT_SPECIALIZATIONS = [
  "醫學生",
  "牙醫學生",
  "中醫學生",
  "藥學生",
  "護理學生",
  "呼吸治療學生",
  "物理治療學生",
  "職能治療學生",
  "醫學檢驗學生",
  "放射學生",
  "營養學生",
  "公衛學生",
  "社工學生",
  "心理學生",
  "其他（請說明）"
];

// 西醫次專科選項
export const WESTERN_MEDICINE_SPECIALTIES = [
  "一般內科",
  "心臟內科",
  "胸腔內科",
  "腸胃內科",
  "腎臟內科",
  "神經內科",
  "內分泌科",
  "血液腫瘤科",
  "感染科",
  "風濕免疫科",
  "一般外科",
  "心臟外科",
  "胸腔外科",
  "神經外科",
  "骨科",
  "整形外科",
  "泌尿外科",
  "小兒科",
  "婦產科",
  "家醫科",
  "復健科",
  "眼科",
  "耳鼻喉科",
  "皮膚科",
  "精神科",
  "急診醫學科",
  "麻醉科",
  "放射診斷科",
  "放射腫瘤科",
  "病理科",
  "核子醫學科",
  "職業醫學科",
  "其他次專科"
];

// Flat list for backward compatibility if needed
export const MEDICAL_ROLES = [
  ...ROLE_CATEGORIES["醫師與牙醫"],
  ...ROLE_CATEGORIES["護理與藥事"],
  ...ROLE_CATEGORIES["相關醫療專業"],
  ...ROLE_CATEGORIES["福音與庶務支援"]
];

// 觀察名單：在此名單內的人員，無論是否有動員紀錄，報名後皆需人工審核 (不會自動上架)
export const WATCHLIST = [
  "測試黑名單",
  "觀察對象A"
];

export const LEADERSHIP_ROLES = [
  "無",
  "隊長",
  "副隊長",
  "護理長",
  "副護理長"
];

export const TASK_ROLES = [
  "尚未分配",
  "西醫",
  "中醫",
  "牙醫",
  "櫃台",
  "藥局",
  "牙科跟診/牙助",
  "跟診",
  "醫檢/心電圖",
  "心靈關懷/宣道",
  "流動",
  "器械載運",
  "媒體宣道/攝影",
  "小小醫師營",
  "供應室/器械消毒",
  "義剪",
  "雅歌事奉樂團",
  "衛教/衛生護理教育",
  "總務/庶務",
  "其他"
];

// Sub-menu options when "跟診" is selected
export const CLINIC_DEPARTMENTS = [
  "內科",
  "外科",
  "兒科",
  "家醫科",
  "眼科",
  "中醫"
];

